// const BASE_URL = process.env.API_BASE_URL || "https://dev.thrio.io";

// endpoints
const GET_CONFIG = `/data/api/types/decode/widgetconfig/:configKey`;
// Updated path (removed '/survey') to match provider route actually used
const GET_AUTH_TOKEN = `/provider/widgetconfig/token-with-authorities/:configKey`;
const POST_CHAT_INIT = `/chats/api/consumer/chats`;
const TRIGGER_CHAT_ACTION = `/chats/api/consumer/chats/:chatWorkItemId`;
const CHAT_STATUS = `/chats/api/consumer/chats/:chatWorkItemId/state`;
const KEEP_ALIVE = `/chats/api/consumer/chats/:chatWorkItemId/keepalive`;
const SET_TYPING = `/chats/api/consumer/chats/:chatWorkItemId/typing`;
const GET_WORKFLOWS = `/workflows/api/presurvey/:campaignId`;
const GET_SURVEY_DETAILS = `/data/api/types/survey/:surveyId`;
const SEND_MESSAGE = `/chats/api/consumer/chats/:workItemId/messages`;
const UPDATE_MESSAGE_STATUS = `/chats/api/consumer/workitems/:workItemId/engagementdata/:messageId/status`;
const GET_REGEX_EXPRESSION = `/data/api/types/regex/:validationId`;
const SUBMIT_CONTACT = "/data/api/types/contact";
const GET_CONTACT = "/data/api/types/contact";
const GET_CONTACT_HISTORY = "/data/api/customer/workitems/:contactId";
const GET_PRIMARYIDENTIFICATION_HISTORY =
  "/data/api/customer/v1/ticket/contact/:primaryIdentificationValue";
const GET_CHAT_HISTORY = "/data/api/customer/workitem/:workitemId";
const SUBMIT_FORM_DATA = "/data/api/types/submission";
const GET_FILE = "/data/api/workitem/:workitemId/signedurl";
const PREVIEW_INIT = "/botengine/api/preview/chats/init";
const GO_HOME = "/chats/api/consumer/chats/:chatWorkItemId/:action";
const GO_HOME_PREVIEW = "/botengine/api/preview/chats/:action";
const WS_URL = `wss://ws-:location/event-relay/websocket`;
// const WS_SURVEY_SUB = "/topic/nextivadev/survey/:surveyId";
const WS_CHAT_SUB = "/topic/:tenant/chat/:chatWorkitemId";
const OFFLINE_EMAIL = "/workflows/api/webchat/offline/sendEmail";
const GET_REGEX = "/workflows/api/webchat/offline/sendEmail";
const GET_TICKET_LIST_HISTORY =
  "/data/api/customer/v1/ticket/contact/:userPrimaryId";
const GET_TICKET_HISTORY =
  "/data/api/customer/v1/ticket/engagementdata/:ticketId";
const EDIT_MESSAGE = `/chats/api/consumer/workitems/:workItemId/engagementdata/:engagementDataId/edit`;
const DELETE_MESSAGE = `/chats/api/consumer/workitems/:workItemId/engagementdata/:engagementDataId/delete`;
const FAQ_FEEDBACK = `/data/api/v1/orc/feedback`;
const GET_AGENT_IMAGE = `/data/api/types/user/:userId/pic`;
const GET_AI_EMPLOYEE_DETAILS = `/data/api/types/aiemployee/:aiEmployeeId`;
const GET_MEDIA_URL = `/data/api/workitem/:workitemId/signedurlresponse?filename=:fileName`;

export default {
  CHAT_STATUS,
  GET_CONFIG,
  GET_AUTH_TOKEN,
  POST_CHAT_INIT,
  TRIGGER_CHAT_ACTION,
  KEEP_ALIVE,
  SET_TYPING,
  GET_WORKFLOWS,
  GET_SURVEY_DETAILS,
  WS_URL,
  // WS_SURVEY_SUB,
  WS_CHAT_SUB,
  SEND_MESSAGE,
  UPDATE_MESSAGE_STATUS,
  SUBMIT_CONTACT,
  GET_CONTACT,
  GET_CONTACT_HISTORY,
  GET_PRIMARYIDENTIFICATION_HISTORY,
  SUBMIT_FORM_DATA,
  GET_FILE,
  PREVIEW_INIT,
  GET_CHAT_HISTORY,
  GO_HOME,
  GO_HOME_PREVIEW,
  OFFLINE_EMAIL,
  GET_REGEX_EXPRESSION,
  GET_TICKET_LIST_HISTORY,
  GET_TICKET_HISTORY,
  DELETE_MESSAGE,
  EDIT_MESSAGE,
  FAQ_FEEDBACK,
  GET_AGENT_IMAGE,
  GET_AI_EMPLOYEE_DETAILS,
  GET_MEDIA_URL,
};
